import {NgModule} from '@angular/core';

import {DaytimeRepository} from './repositories/daytime.repository';
import {DaytimeService} from './services/daytime.service';

import {InteractionRepository} from './repositories/interaction.repository';
import {InteractionService} from './services/interaction.service';

@NgModule({
    providers: [
        DaytimeRepository,
        DaytimeService,
        InteractionRepository,
        InteractionService,
    ],
})
export class DaytimeModule { }
